export const getProjectDetailsGeometryTriggerId = () => `projectDetailsGeometryTrigger`;
